import { render, staticRenderFns } from "./new-notice.vue?vue&type=template&id=0cd575b8&scoped=true&"
import script from "./new-notice.vue?vue&type=script&lang=js&"
export * from "./new-notice.vue?vue&type=script&lang=js&"
import style0 from "./new-notice.vue?vue&type=style&index=0&id=0cd575b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd575b8",
  null
  
)

export default component.exports